import React, { useState } from "react";
import {
  Grid,
  Button,
  useMediaQuery,
  useTheme,
  IconButton,
  Drawer,
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import { Link, useLocation } from "react-router-dom";
import { navItems } from "../../frontends/home/data/data";

const Navbar: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const location = useLocation();
  const [drawerOpen, setDrawerOpen] = useState(false);

  return (
    <>
      <Grid
        container
        justifyContent={isMobile ? "space-between" : "center"}
        alignItems="center"
        spacing={isMobile ? 0 : 10}
        sx={{
          width: "100%",
          py: 2,
          px: isMobile ? 3 : 0,
          background: "linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 100%)",
          position: "sticky",
          top: 0,
          zIndex: 100,
        }}
      >
        {isMobile ? (
          <>
            <Grid>
              <Button
                component={Link}
                to="/"
                sx={{
                  color: "#64ffda",
                  fontFamily: "Montserrat, sans-serif",
                  fontWeight: 700,
                  fontSize: "1rem",
                  letterSpacing: "2px",
                  textTransform: "uppercase",
                  "&:hover": { backgroundColor: "transparent" },
                }}
              >
                Bradley Rushforth
              </Button>
            </Grid>
            <Grid>
              <IconButton
                onClick={() => setDrawerOpen(true)}
                sx={{ color: "#a8b2d8" }}
              >
                <MenuIcon />
              </IconButton>
            </Grid>
          </>
        ) : (
          navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Grid key={item.label}>
                <Button
                  component={Link}
                  to={item.path}
                  sx={{
                    color: isActive ? "#64ffda" : "#a8b2d8",
                    fontSize: "0.95rem",
                    fontFamily: "Montserrat, sans-serif",
                    fontWeight: isActive ? 600 : 400,
                    letterSpacing: "1.5px",
                    textTransform: "uppercase",
                    borderBottom: isActive
                      ? "2px solid #64ffda"
                      : "2px solid transparent",
                    borderRadius: 0,
                    pb: 0.5,
                    "&:hover": {
                      color: "#64ffda",
                      backgroundColor: "transparent",
                      borderBottom: "2px solid rgba(100, 255, 218, 0.5)",
                      transition: "color 0.5s, border-bottom 0.5s",
                    },
                  }}
                >
                  {item.label}
                </Button>
              </Grid>
            );
          })
        )}
      </Grid>

      <Drawer
        anchor="right"
        open={drawerOpen}
        onClose={() => setDrawerOpen(false)}
        PaperProps={{
          sx: {
            width: 260,
            background: "linear-gradient(135deg, #0f0f0f 0%, #1a1a2e 100%)",
            borderLeft: "1px solid rgba(100, 255, 218, 0.1)",
          },
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "flex-end",
            p: 2,
          }}
        >
          <IconButton
            onClick={() => setDrawerOpen(false)}
            sx={{ color: "#a8b2d8" }}
          >
            <CloseIcon />
          </IconButton>
        </Box>

        <List sx={{ px: 2 }}>
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <ListItem key={item.label} disablePadding sx={{ mb: 1 }}>
                <ListItemButton
                  component={Link}
                  to={item.path}
                  onClick={() => setDrawerOpen(false)}
                  sx={{
                    borderRadius: 1,
                    borderLeft: isActive
                      ? "3px solid #64ffda"
                      : "3px solid transparent",
                    pl: 2,
                    "&:hover": {
                      backgroundColor: "rgba(100, 255, 218, 0.06)",
                    },
                  }}
                >
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      sx: {
                        color: isActive ? "#64ffda" : "#a8b2d8",
                        fontFamily: "Montserrat, sans-serif",
                        fontWeight: isActive ? 600 : 400,
                        fontSize: "0.95rem",
                        letterSpacing: "1.5px",
                        textTransform: "uppercase",
                      },
                    }}
                  />
                </ListItemButton>
              </ListItem>
            );
          })}
        </List>
      </Drawer>
    </>
  );
};

export default Navbar;
